import { render, staticRenderFns } from "./OnboardingWizardHeader.vue?vue&type=template&id=0e7c27ed&scoped=true"
import script from "./OnboardingWizardHeader.vue?vue&type=script&lang=js"
export * from "./OnboardingWizardHeader.vue?vue&type=script&lang=js"
import style0 from "./OnboardingWizardHeader.vue?vue&type=style&index=0&id=0e7c27ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7c27ed",
  null
  
)

export default component.exports